import React from "react";
import { ENVELOPE_STATUS, actionMap } from "@/utils/constants/constants";
import { NO_RECIPIENT_FOUND } from "@/utils/constants/messages";

interface EnvelopRecipientCardProps {
    recipients: any[];
    emptyMessage?: string;
    emptyClassName?: string;
}

const EnvelopRecipientCard: React.FC<EnvelopRecipientCardProps> = ({
    recipients,
    emptyMessage = NO_RECIPIENT_FOUND,
    emptyClassName = "gs-detail-empty",
}) => {
    return (
        <ul className="data-list is-compact m-0 list-none p-0">
            {recipients.length > 0 ? (
                recipients.map((rec, key) => (
                    <li key={key} className="data-item" style={{ display: "block" }}>
                        <div className="data-col">
                            <div className="data-label label">
                                <div className="info">
                                    <h6 className="title">
                                        <span className="name" id={`envelope-detail-recipient-name-${key}`}>
                                            {rec.full_name}
                                        </span>
                                    </h6>
                                    <span className="text-soft" id={`envelope-detail-recipient-email-${key}`}>
                                        {rec.email_address}
                                    </span>
                                </div>
                            </div>
                            <div className="data-label label" aria-hidden="true" />
                            <div className="data-label label">
                                <span>
                                    {rec.status === "signed" ? (
                                        <div className="info">
                                            <h6 id={`envelope-detail-recipient-status-${key}`}>
                                                {rec.sign_action === "CAN_SIGN" ? "Signed" : "Received"}
                                                <em
                                                    className="icon ni ni-pen-fill ml-1"
                                                    id={`envelope-detail-recipient-status-icon-${key}`}
                                                />
                                            </h6>
                                            <span className="version">
                                                <span
                                                    className="text-soft"
                                                    id={`envelope-detail-recipient-signed-at-${key}`}
                                                >
                                                    At {new Date(rec.signed_at).toLocaleString()}
                                                </span>
                                            </span>
                                        </div>
                                    ) : rec.status === "declined" ? (
                                        <div className="info">
                                            <h6 id={`envelope-detail-recipient-status-${key}`}>
                                                {ENVELOPE_STATUS.DECLINED_TO_SIGN}
                                                <em
                                                    className="icon ni ni-pen-fill ml-1"
                                                    id={`envelope-detail-recipient-status-icon-${key}`}
                                                />
                                            </h6>
                                            <span className="version">
                                                <span
                                                    className="text-soft"
                                                    id={`envelope-detail-recipient-declined-at-${key}`}
                                                >
                                                    At {new Date(rec.declined_at).toLocaleString()}
                                                </span>
                                                <br />
                                                <span
                                                    className="text-soft"
                                                    id={`envelope-detail-recipient-declined-reason-${key}`}
                                                >
                                                    Reason: {rec.decline_reason}
                                                </span>
                                            </span>
                                        </div>
                                    ) : (rec.status === "waiting" || rec.status === "current") ? (
                                        <div className="info">
                                            <h6 id={`envelope-detail-recipient-status-${key}`}>
                                                {actionMap[rec.sign_action]}
                                                <em
                                                    className="icon ni ni-pen-fill ml-1"
                                                    id={`envelope-detail-recipient-status-icon-${key}`}
                                                />
                                            </h6>
                                            {rec.status === "current" ? (
                                                <span className="version">
                                                    <span
                                                        className="text-soft"
                                                        id={`envelope-detail-recipient-sent-at-${key}`}
                                                    >
                                                        Sent at {new Date(rec.sent_at).toLocaleString()}
                                                    </span>
                                                </span>
                                            ) : null}
                                        </div>
                                    ) : null}
                                </span>
                            </div>
                        </div>
                    </li>
                ))
            ) : (
                <li className={emptyClassName}>
                    <p className="m-0" id="envelope-detail-no-recipient-data-message">
                        {emptyMessage}
                    </p>
                </li>
            )}
        </ul>
    );
};

export default EnvelopRecipientCard;
